import { createContext } from "react";

const adminContext = createContext();

export default adminContext;
